import colors from 'vuetify/lib/util/colors'

export default {
  color: '#4EA8B4',
  failedColor: colors.red.base
}
